import withField from '~hocs/withField';
import { Props } from './types';
import * as Styled from './styled';

export function CurrencyInput({ onChange, ...props }: Props) {
  const handleChange = (value: string, name: string) => {
    const event = { target: { value, name } };

    onChange(event);
  };

  return (
    <Styled.CurrencyInput
      prefix="R$ "
      groupSeparator="."
      decimalSeparator=","
      decimalsLimit={2}
      allowNegativeValue={false}
      onValueChange={handleChange}
      {...props}
    />
  );
}

export default withField(CurrencyInput);
